import React from 'react';

export default ({ size }) => (
  <div className="progress-overlay rounded">
    <div className={`progress-animate spinner-border text-info ${size ? `progress-animate-${size}` : ''}`} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);
